<template>
  <div class="category-list">
    <div v-for="(item, index) in searchData" :key="index" class="product">
      <div class="items">
        <div class="items-list">
          <div class="title-style">
            <img alt="" src="@/assets/imgs/match/店铺@2x.png">
            <span>华东化工销售公司</span>
            <img alt="" src="@/assets/imgs/toProduct/111.png">
          </div>
          <div style="display: flex">
            <div class="items-list-left">
              <van-image :src="item.commodityImage ? item.commodityImage : simpleImg" class="items-img" fit="contain"/>
            </div>

            <div class="items-list-right">
              <h4 class="title white-space2">{{ item.description }}</h4>
              <div class="info">
                <p class="white-space">产品编码：{{ item.materialCode }}</p>
                <p class="white-space">
                  生产企业：{{ item.productionEnterprise }}
                </p>
              </div>
            </div>
          </div>
          <div class="btn-check">
            <van-button round type="danger" @click="getTradeList(item)">查看合约销售 ></van-button>
          </div>
        </div>
      </div>

      <div v-for="(it, i) in item.tradeList" :key="i" class="item-title" @click.stop.prevent="goDetails(it,2)">
        <div class="list-left">
          <span>挂牌编码：{{ it.tradeNo }}</span>
          <span>产品编码：{{ item.materialCode }}</span>
          <span>下架时间：{{
              it.offShelvesTime == null ? "--" : it.offShelvesTime
            }}</span>
          <span>价格方式： {{ it.saleModes[0] }}</span>
          <span>可售量：{{ it.availableQuantity }} 吨</span>
          <span>仓库名称：{{ it.warehouseName }}</span>
        </div>

        <div class="list-right">
          <span v-if="it.directMode=='private'" class="tag-div1">专属</span>
          <span v-if="it.directMode=='public'" class="tag-div3">公开</span>
          <span v-if="it.directMode=='group'" class="tag-div2">共享</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import planSaleApi from "@/request/planSaleApi";
import {getStore} from "@/store/storage.js";

export default {
  name: "TopProductList",
  data() {
    return {
      simpleImg: require("assets/imgs/默认产品图.png"),
      productType: {
        public: "公开",
        group: "共享",
        private: "专属",
      },
      formPage: {
        pageSize: 5,
        currentPage: 1,
      },
    };
  },
  props: {
    searchData: Array,
  },
  computed: {
    directModeName() {
      let directModeName;
      switch (this.searchData.tradeList.directMode) {
        case "public":
          directModeName = "公开";
          break;
        case "group":
          directModeName = "共享";
          break;
        case "private":
          directModeName = "专属";
          break;
      }
      return directModeName;
    },
  },
  created() {
    this.isLogin = getStore("userInfo") !== null;
  },
  methods: {
    goDetails(it) {
      if (this.isLogin === false) {
        this.$dialog.confirm({
          title: '提示',
          message: '请先登录，再查看相关信息！',
        }).then(() => {
          this.$router.push("/Login?backRoute=" + this.$route.fullPath);
        }).catch(() => {
        });
        return false;
      }
      let id = it.id,
          directMode = it.directMode;
      this.$router.push(
          "/planSaleDetails?id=" + id + "&directMode=" + directMode
      );
    },

    getTradeList(val) {
      let params = Object.assign({}, this.formPage);
      params.beginPage = params.currentPage
      params.commodityId = val.id;
      planSaleApi.getSearchProduct(params).then((res) => {
        if (res.result.searchData.totalRows == 0) {
          this.$toast.fail("暂无合约销售产品");
        } else {
          let idx = this.searchData.findIndex(
              (product) => product.materialCode == val.materialCode
          );
          this.searchData[idx] =
              idx > -1 ? res.result.searchData.dataList[0] : "";
          this.searchData[idx].tradeList =
              res.result.searchData.dataList[0].tradeList;
          // this.searchData[idx].type = "plan";
          this.searchData[idx].id = val.id;
          this.$forceUpdate();
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.btn-check {
  padding-top: 20px;
  margin-left: 28%;

  >>> .van-button--danger {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    background: transparent;
    border: 1px solid transparent;
  }
}

.product {
  background-color: #fff;
  margin-bottom: 32px;
  border-radius: 20px;
}

.white-space2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product .items {
  position: relative;
  padding: 38px 24px;
}

.items-list .items-list-left {
  .items-img {
    width: 176px;
    height: 176px;
  }
}

.items-list .items-list-right {
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    line-height: 36px;
  }

  .info {
    .white-space {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      line-height: 30px;
    }
  }
}

.items-list .title-style {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  img:nth-child(1) {
    width: 32px;
    height: 32px;
  }

  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    line-height: 44px;
    margin: 0 12px;
  }

  img:nth-child(3) {
    width: 11.16px;
    height: 21px;
  }
}

.product .items >>> .van-image {
  padding-right: 15px;
}

.product >>> .van-image__error, .product >>> .van-image__img, .product >>> .van-image__loading {
  border-radius: 20px;
}

.product .list {
  line-height: 50px;
  display: grid;
  grid-template-columns: 14fr 5fr;
}

.product .list-left {
  display: inline-block;
}

.width60 {
  width: 60%;
}

.width70 {
  width: 70%;
}

.width30 {
  width: 30%;
}

.width40 {
  width: 40%;
}

.width50 {
  /* width: 40%; */
}

.product .list-right {
  display: inline-block;
  text-align: left;
}

.product .items .info p {
  padding-top: 20px;
}

.category-list .viewmore {
  color: #8e8b8b;
}

.product .tag-div {
  padding: 10px;
  margin-right: 10px;
}

.product .item-title {
  width: 100%;
  min-height: 328px;
  background: #f7f7f7;
  border-radius: 16px 16px 16px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 32px;
  box-sizing: border-box;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  line-height: 40px;
  color: #666666;
  position: relative;

  .list-left {
    gap: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    span {
      min-height: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #666666;
      line-height: 33px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .list-right {
    .tag-div1 {
      width: 80px;
      height: 36px;
      font-family: PingFang SC, PingFang SC;
      border-radius: 4px 4px 4px 4px;
      font-weight: 400;
      font-size: 24px;
      line-height: 24px;
      position: absolute;
      top: 34px;
      right: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tag-div2 {
      width: 80px;
      height: 36px;
      background: rgba(255, 85, 0, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid rgba(255, 85, 0, 0.5);
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #FF5500;
      text-align: center;
      line-height: 36px;
      position: absolute;
      top: 32px;
      right: 32px;
    }

    .tag-div3 {
      width: 80px;
      height: 36px;
      background: rgba(89, 223, 174, 0.1);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #59DFAE;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #59DFAE;
      text-align: center;
      line-height: 36px;
      position: absolute;
      top: 32px;
      right: 32px;
    }
  }
}
</style>